<div class="visit-selection-item">
	<ng-container *ngIf="!visit.isNewVisit; else newVisitItem">
		<div class="visit-num">
			<span class="visit-item" >
				{{ ('VisitNumber' | cpLabelTranslate)  + ' : '  +  visit.visitNumber }}
			</span>
		</div>
		<div class="visit-details">
			<span>{{('AdmissionDate' | cpLabelTranslate)  + ' : ' }} </span>
			<span class="visit-admission-date">{{visit.admitDateTime ? (visit.admitDateTime | cpDate) : '' }}</span>
			<span> &nbsp; | &nbsp; </span>
			<span>{{('PatientType' | cpLabelTranslate)  + ' : ' }} </span>
			<span class="visit-patient-type">{{visit.patientClass}}</span>
		</div>
	</ng-container>
	<ng-template #newVisitItem>
		<div class="visit-num">
			<span  class="visit-item new-visit-item" >
				{{ 'CreateNewVisit' | cpLabelTranslate }}
			</span>
		</div>
	</ng-template>
</div>

